import { useMutation } from "@tanstack/react-query"
import resetPasswordService from "services/resetPassword.service"

export const useResetPassword = () => {
	return useMutation({
		mutationKey: ["resetPassword"],
		mutationFn: async (email: string) => resetPasswordService.resetPassword(email),
	})
}

export const useResetPasswordConfirm = () => {
	return useMutation({
		mutationKey: ["resetPasswordConfirm"],
		mutationFn: async ({
			uid,
			password,
			token,
			reNewPassword,
		}: {
			uid: string | null
			password: string
			token: string | null
			reNewPassword: string
		}) => resetPasswordService.resetPasswordConfirm(uid, password, token, reNewPassword),
	})
}
